import { useEffect, useMemo, useState } from 'react';
import { DEFAULT_SHIPPING_FEE } from './shipping';

export function useShipping() {
  const [saved, setSaved] = useState(null);

  useEffect(() => {
    let alive = true;
    fetch('/api/shipping', { credentials: 'same-origin' })
      .then((response) => (response.ok ? response.json() : null))
      .then((data) => {
        if (alive) setSaved(data?.fees ?? {});
      })
      .catch(() => {
        if (alive) setSaved({});
      });
    return () => {
      alive = false;
    };
  }, []);

  const fees = useMemo(() => {
    const listed = Object.entries(saved ?? {}).filter(
      ([name, fee]) => name.trim() && Number.isFinite(Number(fee)) && Number(fee) >= 0
    );
    return listed.length ? Object.fromEntries(listed) : DEFAULT_SHIPPING_FEE;
  }, [saved]);

  return {
    ready: saved !== null,
    fees,
    governorates: Object.keys(fees),
    getFee: (governorate) => fees[governorate] ?? null,
  };
}
